import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

const textareaVariants = cva(
  'mobile-input-text flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:ring-destructive/40',
  {
    variants: {
      sizing: {
        content: 'field-sizing-content min-h-16',
        fill: 'field-sizing-fixed h-full min-h-0 flex-1 resize-none break-words',
      },
    },
    defaultVariants: { sizing: 'content' },
  }
)

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>
>(({ className, sizing, ...props }, ref) => {
  return (
    <textarea
      data-slot='textarea'
      ref={ref}
      className={cn(textareaVariants({ sizing }), className)}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
